import React from "react";
import shell from "../assets/shell.jpeg";
import chatbot from "../assets/chatbot.webp";
import dumbo from '../assets/dumbo-front.png'
import helka from '../assets/helka-front.png';
import financeTracker from '../assets/finance_tracker.png';
import jobquest from "../assets/jobquest-mock.png";
import recycnet from "../assets/recycnetai.png";

function Projects() {
  return (
    <div id="projects" className="grid">
      <h2 className="title">Projects</h2>
      <div className="projects grid projects-grid">
      <div className="project-card">
          <div className="recycnet wrapper">
            <h3 className="project-title">Recycnet AI</h3>
            <p className="project-description">
                A waste classification web app using EfficientNet & FastAPI. Achieved 90%+ accuracy and deployed for real-world use.
            </p>
            <div className="image-wrapper">
              <img className="helka-mock" src={recycnet} alt="" />
            </div>
            <div className="project-card-actions">
              <a
                style={{ textDecoration: "none", color: "#e4e4e5" }}
                href="https://github.com/iam-tarun/Recycnet-AI"
                target="_blank"
                rel="noreferrer"
              >
                <button className="button">View Project</button>
              </a>
              <a style={{ textDecoration: "none" }} href="https://recycnetai.tarunteja.dev" target="_blank" rel="noreferrer">
                
                <button className="button" >Live Demo</button>
              </a>
            </div>
          </div>
        </div>
        <div className="project-card">
          <div className="jobquest wrapper">
            <h3 className="project-title">Job Quest</h3>
            <p className="project-description">
                A full-stack job application tracker to manage roles, interviews, and company data — powered by JWT auth, RESTful APIs, and MySQL. Built to streamline job search workflows.
            </p>
            <div className="image-wrapper">
              <img className="jobquest-mock" src={jobquest} alt="" />
            </div>
            <div className="project-card-actions">
              <a
                style={{ textDecoration: "none", color: "#e4e4e5" }}
                href="https://github.com/iam-tarun/JobQuest"
                target="_blank"
                rel="noreferrer"
              >
                <button className="button">View Project</button>
              </a>
              <a style={{ textDecoration: "none" }} href="https://jobquest.tarunteja.dev" target="_blank" rel="noreferrer">
                
                <button className="button" >Live Demo</button>
              </a>
            </div>
          </div>
        </div>
        <div className='project-card'>
              
              <div className="finance-tracker wrapper">
              <h3 className="project-title">Finance Tracker</h3>
              <p className="project-description">
              A personal finance tracker built with Flutter and Firebase — offering real-time expense tracking, budget insights, and category-wise breakdowns to help users stay on top of their financial goals.
            </p>
            <div className="image-wrapper">
              <img className="jobquest-mock" src={financeTracker} alt="" />
            </div>
            <div className="project-card-actions">
            <a 
                style={{textDecoration: 'none', color: '#e4e4e5'}} 
                href='https://github.com/iam-tarun/finance-tracker' target='_blank' rel='noreferrer'>
              <button className='button' >
              View Project
              </button>
                </a>
              
            </div>
            
              </div>
            </div>
          <div className='project-card'>
  
              <div className="helka wrapper">
              <h3 className="project-title">Helka</h3>
              <p className="project-description">
              A secure, personalized news web app that fetches keyword-relevant articles and lets users save them for future reference. Built with a focus on privacy and content control.
            </p>
            <div className="image-wrapper">
              <img className="helka-mock" src={helka} alt="helka web app" />
            </div>
            <div className="project-card-actions">
            <a 
              style={{textDecoration: 'none', color: '#e4e4e5'}} 
              href='https://github.com/iam-tarun/helka' target='_blank' rel='noreferrer'>

            <button className='button' >
            View Project
            </button>
              </a>
            </div>
            
              </div>
          </div>
          <div className="project-card">
              <div className="dumbo wrapper">
              <h3 className="project-title">Dumbo</h3>
              <p className="project-description">
              A document management tool with tagging and search powered by Google OCR. Uses PostgreSQL and Google Cloud Storage to store, tag, and retrieve files with smart automation.
            </p>
            <div className="image-wrapper">
              <img className="helka-mock" src={dumbo} alt="dumbo web app" />
            </div>
            <div className="project-card-actions">
            <a 
              style={{textDecoration: 'none', color: '#e4e4e5'}} 
              href='https://github.com/iam-tarun/dumbo' target='_blank' rel='noreferrer'>
            <button className='button' >
              View Project
            </button>
              </a>
            </div>
            
              </div>
          </div>
          <div className="project-card">
              <div className="planetbot wrapper">
              <h3 className="project-title">Planet Bot</h3>
              <p className="project-description">
              A chatbot that answers questions using TF-IDF + cosine similarity. Achieved 83% accuracy in fetching relevant answers from a dataset of planetary information.
            </p>
            <div className="image-wrapper">
              <img className="helka-mock" src={chatbot} alt="dumbo web app" />
            </div>
            <div className="project-card-actions">
            <a 
              style={{textDecoration: 'none', color: '#e4e4e5'}} 
              href='https://github.com/iam-tarun/PlanetBot' target='_blank' rel='noreferrer'>
            <button className='button' >
              View Project
            </button>
              </a>
            </div>
            
              </div>
          </div>
          <div className="project-card">
              <div className="shell wrapper">
              <h3 className="project-title">Shell</h3>
              <p className="project-description">
              A custom-built Unix shell in C with support for built-in and external commands, background processing, and piping — built from scratch to learn OS-level process management.
            </p>
            <div className="image-wrapper">
              <img className="helka-mock" src={shell} alt="shell" />
            </div>
            <div className="project-card-actions">
            <a 
              style={{textDecoration: 'none', color: '#e4e4e5'}} 
              href='https://github.com/iam-tarun/Linux-shell' target='_blank' rel='noreferrer'>
            <button className='button' >
              View Project
            </button>
              </a>
            </div>
            
              </div>
          </div>
      </div>
    </div>
  );
}

export default Projects;
